import React from 'react';

const ErrorPage = () => {
	return (
		<div className='flex h-80 justify-center items-center text-2xl font-bold'>
			Sorry, we're unable to process your request currently.
			We'll be right back very soon.
		</div>
	);
};

export default ErrorPage;
